import React from "react";
import { PadlockLockedFillIcon } from "@navikt/aksel-icons";
import { useI18n } from "../util/i18n/i18n.context.js";
export const ReadOnlyIcon = () => (React.createElement(PadlockLockedFillIcon, { "aria-hidden": true, className: "navds-form-field__readonly-icon" }));
export const ReadOnlyIconWithTitle = () => (React.createElement(PadlockLockedFillIcon, { title: useI18n("global")("readOnly"), className: "navds-form-field__readonly-icon" }));
//# sourceMappingURL=ReadOnlyIcon.js.map